import { FC, ReactNode, useCallback, useState } from 'react';
import { OverbygningContext, OverbygningWithErrors } from '../context/OverbygningContext.tsx';
import { MessageType } from '../../components/atoms/Messages/Message.tsx';
import { Overbygning } from '../Utils/types/Overbygning.ts';

interface OverbygningContextProps {
	children: ReactNode;
}

export const OverbygningContextProvider: FC<OverbygningContextProps> = ({ children }) => {
	const [overbygningWithErrors, setOverbygningWithErrors] = useState<OverbygningWithErrors[]>([]);

	const deleteOverbygning = useCallback((index: number) => {
		setOverbygningWithErrors((prevState) => {
			const newState = [...prevState];
			newState.splice(index, 1);
			return newState;
		});
	}, []);
	const addOverbygning = useCallback((overbygning: Overbygning) => {
		setOverbygningWithErrors((prevState) => [...prevState, { overbygning, feilmelding: [] }]);
	}, []);
	const updateOverbygninger = useCallback((overbygning: Overbygning, index: number) => {
		setOverbygningWithErrors((prevState) => {
			const newState = [...prevState];
			newState[index] = {
				overbygning,
				feilmelding: [],
			};
			return newState;
		});
	}, []);
	const updateFeilmeldinger = useCallback((feilmeldinger: MessageType[], index: number) => {
		setOverbygningWithErrors((prevState) => {
			const newState = [...prevState];
			newState[index] = {
				overbygning: newState[index].overbygning,
				feilmelding: feilmeldinger,
			};
			return newState;
		});
	}, []);
	return (
		<OverbygningContext.Provider
			value={{
				deleteOverbygning,
				addOverbygning,
				updateOverbygninger,
				overbygningWithErrors,
				updateFeilmeldinger,
			}}
		>
			{children}
		</OverbygningContext.Provider>
	);
};
